const REDIRECT_BASE = "https://geominer.ca";
export const DEFAULT_SIGNUP_DESTINATION = "/account?welcome=1";

/** Accept only same-origin app paths and avoid redirect loops back to Account. */
export function getSafeInternalRedirect(value: string | null, fallback = "/") {
  const hasUnsafeCharacter = value
    ? Array.from(value).some((character) => {
        const code = character.charCodeAt(0);
        return character === "\\" || code < 32 || code === 127;
      })
    : false;
  if (!value?.startsWith("/") || hasUnsafeCharacter) return fallback;

  try {
    const target = new URL(value, REDIRECT_BASE);
    if (
      target.origin !== REDIRECT_BASE
      || target.pathname === "/account"
      || target.pathname.startsWith("/account/")
    ) return fallback;
    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return fallback;
  }
}

export function getSafeSignupRedirect(value: string | null) {
  return getSafeInternalRedirect(value, DEFAULT_SIGNUP_DESTINATION);
}
